module.exports = __webpack_public_path__ + "img/TUIfly.3b535bf1.jpg";